export enum GameEnum {
  InitFetchPosts = 'InitFetchPosts',
  FailFetchPosts = 'FailFetchPosts',
  SuccessFetchPosts = 'SuccessFetchPosts',
  SetFormValues = 'SetFormValues',
  CleanGameData = 'CleanGameData',
  SaveGameStatus = 'SaveGameStatus',
  CleanIsReadyToGameData = 'CleanIsReadyToGameData',
  SaveActiveGameData = 'SaveActiveGameData',
  RandomizeTask = 'RandomizeTask',
  CleanCurrentTask = 'CleanCurrentTask',
  SetPoints = 'SetPoints',
  CleanGameAlerts = 'CleanGameAlerts',
}
